(function() {
  'use strict';
  
  angular
    .module('app.data')
    .factory('marsService', marsService);
    
  marsService.$inject = ['$rootScope', '$log', '$q'];    
  
  function marsService($rootScope, $log, $q) {
    $log = $log.getInstance('marsService');
   
    var socket = null;
    var pendingListeners = [];
    
    return {
      clone: clone,
      depopulate: depopulate,
      id: id,
      on: on,
      publish: publish,
      request: request
    }
    
    
    function clone(obj, keys) {
      $log.debug('keys = ', keys);
      if (angular.isString(keys)) {
        keys = [keys];
      }
      if (angular.isArray(keys)) {
        keys = _.union(keys, ['_id']);
        return _.pick(obj, keys);
      }
      else {
        return _.clone(obj);
      }
    }
    
    
    function depopulate(obj, keys, idField) {
      idField = idField || '_id';
      if (angular.isString(keys)) {
        keys = [keys];
      }
      if (angular.isArray(keys)) {
        keys.forEach(function(key) {
          if (angular.isObject(obj[key]) && _.has(obj[key], idField))
            obj[key] = obj[key][idField];
          else if (angular.isArray(obj[key]))
            obj[key] = _.map(obj[key], function(subObj) {
              return _.has(subObj, idField)
                ? subObj[idField]
                : subObj
            });
        });
      }
    }
    
    function id(obj) {
      if (angular.isObject(obj) && _.has(obj, '_id'))
        return obj._id;
      if (angular.isString(obj))
        return obj;
      return null;
    }
    
    function on(name, listener) {
      if (!socket) {
        pendingListeners.push({ name: name, listener: listener });
        return;
      }
      $rootScope.$on(name, listener);
      if (!socket.hasListeners(name)) {
        socket.on(name, function(data) {
          $log.debug('Received: ' + name + ' [event]');
          $rootScope.$apply(function() {
            $rootScope.$emit(name, data);
          });
        });
      }
    }

    /**
     * Send data to the server without expecting a response.
     * 
     * Some actions like metrics don't need a response and should resolve
     * straight away. 
     * 
     * There's probably a better name than `publish` - feel free to change it
     * if you think of something better.
     * 
     * @param {string} endpoint API endpoint path 
     * @param {*} data 
     * 
     * @return {Promise}
     */
    function publish(endpoint, data) {
      if (!socket)
        _init();

      $log.debug('Sent: ' + endpoint, data);
      socket.emit(endpoint, data);
      return $q.resolve();
    }

    /**
     * Send a request to the server and resolve after receiving a response.
     * 
     * This is the standard way of interacting with the server. Most API 
     * endpoints reply to confirm the success or failure of the request and 
     * to provide data back to the client.
     * 
     * Replies are identified by the endpoint only, there is no sequence field
     * to match replies to requests. It's important to wait for the reply 
     * before sending additional requests.
     * 
     * @param {string} endpoint API endpoint path 
     * @param {*} data 
     * 
     * @return {Promise}
     */
    function request(endpoint, data) {
      var d = $q.defer();
      
      if (!socket)
        _init();
     
      socket.once(endpoint, function(responseData) {
        $log.debug('Received: ' + endpoint + ' [response]', responseData);
        $rootScope.$apply(function() {
          if (responseData && responseData.hasOwnProperty('error')) {
            $log.error(
              'Failed: ' 
              + responseData.error.code 
              + ' - ' 
              + responseData.error.message
            );
            d.reject(responseData.error);
          }
          else {
            d.resolve(responseData);
          }
        });
      });
      
      $log.debug('Sent: ' + endpoint);
      socket.emit(endpoint, data);
      return d.promise;
    }
    
    
    function _init() {
      try { socket = io(); }
      catch (err) { $log.error(err); }
      pendingListeners.forEach(function(l) {
        on(l.name, l.listener);
      });
      pendingListeners = [];
    }
    
  }
  
})();
